import { MenuItem } from '@mui/material';

export const DisabledChoiceAutocompleteNote = () => {
	return (
		<MenuItem sx={{ pointerEvents: 'none' }} aria-disabled>
			Введіть ще кілька знаків
		</MenuItem>
	);
};
